












































import { Component, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { getStartGuideType } from '@/utils/start-guide';
import { IBusinessType } from '@/models/business';

import EmailAutomationIcon from '@/components/icons/EmailAutomation.vue';
import InviteCustomersIcon from '@/components/icons/InviteCustomers.vue';
import SocialRewardsIcon from '@/components/icons/SocialRewards.vue';
import ReferralProgramIcon from '@/components/icons/ReferralProgram.vue';

import CircleLock from '@/componentsV2/atoms/CircleLock/CircleLock.vue';

import { getFeaturesMapper } from './features';
import InfoIcon from '@/components/icons/Info.vue';
import BillingModel from '@/views/Models/BillingModel.vue';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';

@Component({
  components: {
    FilledButton,
    EmailAutomationIcon,
    InviteCustomersIcon,
    SocialRewardsIcon,
    ReferralProgramIcon,
    CircleLock,
    InfoIcon,
    CoinNetworkFeatureTag
  }
})
export default class LaunchRewardsProgramEmptyState extends BillingModel {
  featuresMapper = getFeaturesMapper();

  get feature() {
    return this.featuresMapper[this.$route.name as string];
  }

  get isBoth() {
    return getStartGuideType() === IBusinessType.BOTH;
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return `connectProvider`;
  }

  get tPrefixFeature() {
    return `connectProvider.${this.feature.slug}`;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  getIconBySlug(slug: string) {
    const slugFormatted = slug
      .toLocaleLowerCase()
      .split('-')
      .join('');

    const actionMapper: Record<string, () => string> = {
      emailautomation: () => 'EmailAutomationIcon',
      invitecustomers: () => 'InviteCustomersIcon',
      socialrewards: () => 'SocialRewardsIcon',
      referralprogram: () => 'ReferralProgramIcon'
    };
    if (!actionMapper[slugFormatted]) return '';

    return actionMapper[slugFormatted]();
  }

  goToIntegrations() {
    this.$router.push('/settings/apps');
  }
}
